module.exports = __webpack_public_path__ + "img/theCover_12.eb8fda16.jpg";